import moment from "moment";

// Event and access times are stored as Pakistan wall-clock time and serialised without a
// timezone (the Ijtima'at table shows them with moment.utc). Convert them to a local Date with the
// same wall-clock time for the date pickers, and back to a timezone-less string for the API.
export const toWallDate = (value) =>
  value ? moment(moment.utc(value).format("YYYY-MM-DDTHH:mm:ss")).toDate() : null;

export const toApiDate = (date) => moment(date).format("YYYY-MM-DDTHH:mm:ss");

export const formatDateTime = (date) =>
  date ? moment(date).locale("en").format("DD MMM YYYY · hh:mm A") : "";

export const formatShortDateTime = (date) =>
  date ? moment(date).locale("en").format("DD MMM, hh:mm A") : "";

// Only these member types may hold a responsibility (mirrors the API check).
export const ASSIGNABLE_MEMBER_TYPES = ["ملتزم", "مبتدی"];

export const ALLOWED_UNIT_TYPES = ["Markaz", "Halqa", "Tanzeem"];

export const canManageAttendanceAccess = (record) =>
  record.isEditable &&
  !record.isParentEvent &&
  ALLOWED_UNIT_TYPES.includes(record.unit?.label1);

// getUnitParticipants returns name as "Member Name - / Unit / Parent / ... / Markaz".
export const parseSearchResult = (item) => {
  const [name, ...rest] = (item.name || "").split(" - ");
  const units = rest
    .join(" - ")
    .split("/")
    .map((u) => u.trim())
    .filter(Boolean);
  return {
    id: item.id,
    name: name.trim(),
    unitName: units.slice(0, 2).join(" ‹ "),
    regNo: item.memberRegNo,
    memberTypeName: item.memberTypeName,
  };
};

export const getAccessStatus = (start, end, now = new Date()) => {
  if (now < start) return "upcoming";
  if (now > end) return "expired";
  return "active";
};

/** Each rule is "ok", "bad" or "wait" (not enough input yet). */
export const getWindowRules = (start, end, eventStart, eventEnd) => ({
  startBeforeEventEnd: !start ? "wait" : start <= eventEnd ? "ok" : "bad",
  endAfterEventStart: !end ? "wait" : end >= eventStart ? "ok" : "bad",
  startBeforeEnd: !start || !end ? "wait" : start < end ? "ok" : "bad",
});

export const initials = (name) => (name || "?").trim().charAt(0);

const AVATAR_COLORS = ["#0d9488", "#4f46e5", "#db2777", "#d97706", "#0284c7", "#7c3aed"];
export const avatarColor = (id) => AVATAR_COLORS[Math.abs(id || 0) % AVATAR_COLORS.length];
